import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=9e8a7d84&scoped=true&"
import script from "./UserAgreement.vue?vue&type=script&lang=js&"
export * from "./UserAgreement.vue?vue&type=script&lang=js&"
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=9e8a7d84&lang=scss&scoped=true&"
import style1 from "./UserAgreement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8a7d84",
  null
  
)

export default component.exports